// © Microsoft Corporation. All rights reserved.

import { ManagedClasses } from "@microsoft/fast-jss-manager";

import { IconCssClasses } from "./Icon.styles";
import * as Glyph from "./icons";
import * as GlyphInline from "./icons/GlyphInline";

export interface IconManagedClasses extends ManagedClasses<IconCssClasses> { }

export type GlyphType = (() => Promise<any>) | string;

export { Glyph, GlyphInline };

/**
 * Property contract for the {CardAction} component
 */
export interface IconHandledProps extends IconManagedClasses {
        /** Icon type props */
        glyphType: GlyphType,
        /** Aria label optional type props */
        ariaLabel?: string,
        width?: string,
        height?: string,
        fill?: string,
        onError?: (error: Error) => void,
        wrapperClassName?: string
}

export interface IconUnhandledProps extends React.HTMLAttributes<HTMLSpanElement> {
}

export type IconProps = IconHandledProps & IconUnhandledProps;